// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"aea933e3812260d9","9622":"65fd0e7b7fa312b7"}[chunkId] + ".css";
};